import React, { useState, useEffect } from 'react';
import MuiAlert, { AlertProps, type Color } from '@material-ui/lab/Alert';
import {
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { type IStatus } from '.';
import { api } from '../../../services/api';
import { Autocomplete } from '@material-ui/lab';
import { ASO } from '@data/tipoAso';
import { status } from '@data/status';
import { ColaboradorProps, SearchCPF } from '@components/SearchCPF';
import { useQuery } from '@tanstack/react-query';
import { NavLink } from '@components/NavLink';
import { Button } from '@components/Button';
import { InputSearchColab } from '@components/InputSearchColab';
import { AppError } from '@utils/AppError';

interface IColaborador {
  id_colaboradores: number;
  matricula_empresa: string;
  matricula_esocial: any;
  nome_completo: string;
  cpf_colaborador: string;
  rg: string;
  data_nascimento: string;
  genero: string;
  cnh: string;
  email: string;
  telefone: string;
  situacao: string;
  nis: string;
  funcao: string;
  setor: string;
  turno: string;
  cnpj: string;
  razao_social: string;
  data_admissao: string;
  horario_trab_entrada: string;
  horario_trab_saida: string;
  local_obra: string;
  cod_ghe: any;
  ghe: string;
}
interface INomeComercial {
  id_clinicas_credenciadas: number;
  contrato: string;
  nome_comercial: string;
  razao_social: string;
  cpf_cnpj: string;
  dias_funcionamento: string;
  cep: string;
  rua: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  nome_med: string;
  crm: string;
  crm_estado: string;
  trabalho_agendamento: string;
  pagamento_adiantado: string;
  telemedicina: string;
  observacao: string;
}

export const NotIsTelemedicina: React.FC<IStatus> = (props) => {
  // console.log(props)

  const [listCredenciado, setListCredenciado] = useState<INomeComercial[]>([]);
  const [selectedNomeComercial, setSelectedNomeComercial] = useState<any>();
  const [searchEmail, setSearchEmail] = useState<any>();
  const [emailAgendamento, setEmailAgendamento] = useState([]);

  const [messageError, setMessageError] = useState('');
  const [loadingColab, setLoadingColab] = useState(false);

  const [statusAgendamento, setStatusAgendameto] = useState<string>('');
  const [cpfColab, setCpfColab] = useState<string>('');
  const [nomeColab, setNomeColab] = useState<string>('');
  const [estado, setEstado] = useState<string>('');
  const [cidade, setCidade] = useState<string>('');
  const [dataAgendamento, setDataAgendamento] = useState<string>('');
  const [horarioAgendamento, setHorarioAgendamento] = useState<string>('');
  const [tipoAso, setTipoAso] = useState<string>('');
  const [obs, setObs] = useState<string>('');
  const [cnpjComercial, setCnpjComercial] = useState<string>('');
  const nome_user = localStorage.getItem('NameUser') || '';

  const [snack, setSnack] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [cod, setCod] = useState('');
  const [severity, setSeverity] = useState<Color>();
  const [ordemChegada, setOrdemChegada] = useState<string>('Sim');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      reqStatus();
    }, 2000);
  }, [props.location.state.tipo_agendamento]);

  async function sendAgendamento() {
    setIsSubmitting(true);
    const hora = new Date();
    const newHora = hora.toLocaleString('pt-BR', { hour12: false });
    const data = {
      status: statusAgendamento,
      observacao: obs,
      tipo_aso: tipoAso,
      horario: horarioAgendamento,
      data_agendamento: dataAgendamento,
      estado,
      cidade,
      tipo_agendamento: props.location.state.tipo_agendamento,
      nome: nomeColab,
      cpf_colaborador: cpfColab,
      num_agenda: null,
      usuario: `${nome_user} ${newHora}`,
      ordem_chegada: ordemChegada,
      email_agendamento: emailAgendamento,
      cpf_cnpj_comer: cnpjComercial,
      nome_comercial: selectedNomeComercial,
      linkDoatendimento: ''
    };
    // console.log(data)

    try {
      const res = await api.post(`/ravim/agendamento`, data);

      setCod(String(res.status));
      setSnack(true);
      setSeverity('success');
      setMessage(res.data.message);
      setTimeout(() => {
        window.location.replace('/agendar');
      });
    } catch (error) {
      if (error instanceof AppError) {
        setCod(String(error.code));
        setSnack(true);
        setSeverity('error');
        setMessage(String(error.message));
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  async function reqStatus() {
    const data = {
      tipo_agendamento: props.location.state.tipo_agendamento,
      tipo: props.location.state.tipo_agendamento
    };

    await api
      .post(`/ravim/telemed-clinicas`, data)
      .then((res) => {
        if (res.status === 200 || res.status === 200) {
          setListCredenciado(res.data);
        } else {
          setListCredenciado([]);
        }
      })
      .catch(() => {
        setListCredenciado([]);
      });
  }

  async function handleSearchCpf(cpf: string) {
    setCpfColab(cpf);

    try {
      setLoadingColab(true);
      if (cpf.length === 14) {
        const response = await api.post(`ravim/pesq-cpf`, {
          cpf_colaborador: cpf
        });
        setNomeColab(response.data.nome_completo);
      }
    } catch (error) {
      if (error instanceof AppError) {
        if (error.code === 400) {
          setNomeColab('');
          setMessageError(error.message);
        }
      }
    } finally {
      setLoadingColab(false);
    }
  }

  useEffect(() => {
    if (cpfColab.length <= 0) {
      setMessageError('');
      setNomeColab('');
    }
    if (nomeColab) {
      setMessageError('');
    }
  }, [cpfColab, nomeColab]);

  return (
    <Container>
      <Typography
        variant="h4"
        align="center"
        style={{ marginBottom: 20, fontWeight: 'bold' }}
      >
        Agendamento Presencial
      </Typography>
      <Paper style={{ padding: 40 }}>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Status
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <FormControl variant="outlined" style={{ width: '20%' }}>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  value={statusAgendamento}
                  onChange={(e: any) => {
                    setStatusAgendameto(e.target.value);
                  }}
                >
                  {status.map((status, index) => (
                    <MenuItem key={index} value={status.value}>
                      {status.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Colaborador
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <InputSearchColab
                label="CPF"
                value={cpfColab}
                onChange={(e) => handleSearchCpf(e.toString())}
                errorShow={!!messageError}
                textError={messageError}
                isLoading={loadingColab}
              />
              <TextField
                label="Nome"
                disabled
                variant="outlined"
                fullWidth
                value={nomeColab}
                onChange={(e) => {
                  setNomeColab(e.target.value);
                }}
              />
            </div>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Atendimento presencial
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <Autocomplete
                defaultValue={null}
                fullWidth
                id="tags-outlined"
                options={listCredenciado}
                getOptionLabel={(option: INomeComercial) =>
                  `${option?.cpf_cnpj}`
                    ? `${option?.nome_comercial} - ${option?.estado} - ${option?.cidade}`
                    : ''
                }
                onChange={(e, newValue: any) => {
                  setSearchEmail(newValue?.cpf_cnpj);
                  setSelectedNomeComercial(newValue?.nome_comercial);
                  setCnpjComercial(newValue?.cpf_cnpj);
                  setCidade(newValue?.estado);
                  setEstado(newValue?.cidade);
                }}
                value={selectedNomeComercial}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Nome Comercial"
                    placeholder="Nome Comercial"
                  />
                )}
              />
            </div>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <TextField
                label="Data do agendamento"
                variant="outlined"
                type="date"
                InputLabelProps={{
                  shrink: true
                }}
                value={dataAgendamento}
                onChange={(e) => {
                  setDataAgendamento(e.target.value);
                }}
              />
              <TextField
                label="Horário"
                type="time"
                variant="outlined"
                InputLabelProps={{
                  shrink: true
                }}
                value={horarioAgendamento}
                onChange={(e) => {
                  setHorarioAgendamento(e.target.value);
                }}
                disabled={ordemChegada === 'Sim'}
              />
              <FormControl>
                <Typography>Atendimento por ordem de chegada</Typography>
                <RadioGroup
                  defaultValue="Sim"
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                  value={ordemChegada}
                  onChange={(e) => {
                    setOrdemChegada(e.target.value);
                  }}
                >
                  <FormControlLabel
                    control={<Radio />}
                    value="Sim"
                    label="Sim"
                    style={{ marginRight: 50 }}
                  />
                  <FormControlLabel
                    control={<Radio />}
                    value="Não"
                    label="Não"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <FormControl variant="outlined" style={{ width: '20%' }}>
                <InputLabel>Tipo de ASO</InputLabel>
                <Select
                  label="Tipo de ASO"
                  value={tipoAso}
                  onChange={(e: any) => {
                    setTipoAso(e.target.value);
                  }}
                >
                  {ASO.map((aso, index) => (
                    <MenuItem key={index} value={aso.value}>
                      {aso.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <TextField
                minRows={4}
                label="OBS"
                multiline
                variant="outlined"
                value={obs}
                onChange={(e) => {
                  setObs(e.target.value);
                }}
                fullWidth
              />
            </div>
          </Grid>
        </Grid>
      </Paper>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 20,
          marginTop: 20
        }}
      >
        <NavLink to={{ pathname: '/agendar', state: { exit: true } }}>
          <Button title="Sair" variantstyle="RED" />
        </NavLink>
        <Button
          title="Cadastrar"
          disabled={isSubmitting}
          onClick={sendAgendamento}
        />
      </div>
      <Snackbar
        open={snack}
        autoHideDuration={2000}
        onClose={() => {
          setSnack(!snack);
        }}
      >
        <MuiAlert
          severity={severity}
          variant="filled"
        >{`${cod} - ${message}`}</MuiAlert>
      </Snackbar>
    </Container>
  );
};
